const hasProductPricesLoaded = ({ membershipPrices, trailerCarePrices }) => {
  return (
    membershipPrices != null &&
    trailerCarePrices != null &&
    Object.keys(membershipPrices).length > 0 &&
    Object.keys(trailerCarePrices).length > 0
  )
}

export default hasProductPricesLoaded
